export const shipping_labels = (state) => state.shipping_labels;
